(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_8e5debd"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.hbScrollProgressInitialized) {
    return;
  }

  window.hbScrollProgressInitialized = true;

  var ticking = false;

  function getVisibleBottom(element) {
    if (!element) {
      return 0;
    }

    var style = window.getComputedStyle(element);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity) === 0
    ) {
      return 0;
    }

    var rect = element.getBoundingClientRect();

    if (rect.height <= 0 || rect.bottom <= 0) {
      return 0;
    }

    return rect.bottom;
  }

  function getHeaderBottom() {
    var selectors = [
      'sticky-header',
      '.header-wrapper',
      '.shopify-section-header-sticky',
      'header.header'
    ];

    var bottom = 0;

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(element) {
        var elementBottom = getVisibleBottom(element);

        if (elementBottom > bottom) {
          bottom = elementBottom;
        }
      });
    });

    return bottom;
  }

  function getBubblesBottom() {
    var bubbles = document.querySelector('.hb-fixed-bubbles');

    if (!bubbles) {
      return 0;
    }

    var rect = bubbles.getBoundingClientRect();

    if (rect.height <= 0 || rect.bottom <= 0) {
      return 0;
    }

    return rect.bottom;
  }

  function updateProgressBars() {
    var wrappers = document.querySelectorAll('.scroll-progress-bar-block');

    if (!wrappers.length) {
      ticking = false;
      return;
    }

    var headerBottom = getHeaderBottom();
    var bubblesBottom = getBubblesBottom();

    var topPosition = Math.max(
      0,
      headerBottom,
      bubblesBottom
    );

    var scrollableHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    var progress = scrollableHeight > 0
      ? (window.scrollY / scrollableHeight) * 100
      : 0;

    progress = Math.min(100, Math.max(0, progress));

    wrappers.forEach(function(wrapper) {
      var bar = wrapper.querySelector('[data-hb-scroll-progress]');
      var fill = wrapper.querySelector('[data-hb-scroll-progress-fill]');

      if (!bar || !fill) {
        return;
      }

      wrapper.style.top = topPosition + 'px';

      fill.style.width = progress + '%';

      bar.setAttribute(
        'aria-valuenow',
        Math.round(progress)
      );
    });

    ticking = false;
  }

  function requestUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;

    window.requestAnimationFrame(function() {
      updateProgressBars();
    });
  }

  window.addEventListener(
    'scroll',
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    'load',
    requestUpdate
  );

  document.addEventListener(
    'shopify:section:load',
    requestUpdate
  );

  document.addEventListener(
    'shopify:section:reorder',
    requestUpdate
  );

  document.addEventListener(
    'shopify:section:select',
    requestUpdate
  );

  document.addEventListener(
    'shopify:block:select',
    requestUpdate
  );

  requestUpdate();

  setTimeout(requestUpdate, 100);
  setTimeout(requestUpdate, 500);
  setTimeout(requestUpdate, 1000);
})();
  } catch(e) { console.error(e); }
})();

})();
